import { createActionType } from 'app/store/utils';

const type = createActionType('startup');

export const INITIALIZE_APPLICATION = type('InitializeApplication');
